import { render } from "./PerformanceChartWh1.vue?vue&type=template&id=2c13b9d6&ts=true"
import script from "./PerformanceChartWh1.vue?vue&type=script&lang=ts"
export * from "./PerformanceChartWh1.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__